import PropTypes from 'prop-types';
import React from 'react';
import { setClassNames } from 'ddc-classnames-js';

const FilterItemList = ({ minBreakpoint, children }) => {
	const classes = ['facet-filter-list', 'mb-0', 'list-inline'];

	if (minBreakpoint !== 'xs') {
		classes.push('d-none');
		classes.push(`d-${minBreakpoint}-inline`);
	}

	return (
		<ul className={setClassNames(classes)}>
			{React.Children.map(children, child => (
				<li className="my-1">{child}</li>
			))}
		</ul>
	);
};

FilterItemList.propTypes = {
	minBreakpoint: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	children: PropTypes.node.isRequired
};

FilterItemList.defaultProps = {
	minBreakpoint: 'lg'
};

export default FilterItemList;
